import { catchError, concatMap, filter, map, mergeMap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import {
  noOperationAction,
  ResourceEffects
} from 'src/app/shared/resource-effects'
import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { ConfigurationOption } from './configuration-option'
import { configurationOptionActions } from './configuration-option.actions'
import * as fromConfigurationOptions from './configuration-option.reducer'
import { ConfigurationOptionService } from './configuration-option.service'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { of } from 'rxjs'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'

@Injectable()
export class ConfigurationOptionEffects
  extends ResourceEffects<ConfigurationOption>
  implements OnInitEffects
{
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public configurationOptionService: ConfigurationOptionService
  ) {
    super(
      fromConfigurationOptions.FEATURE_NAME,
      configurationOptionService,
      configurationOptionActions,
      actions$
    )
  }

  ngrxOnInitEffects() {
    return configurationOptionActions.initActions()
  }

  initActions = createEffect(() =>
    this.actions$.pipe(
      ofType(configurationOptionActions.initActions),
      // disable client side cache
      // withLatestFrom(
      //   this.store.select(configurationOptionSelectors.selectState)
      // ),
      // filter(([action, configurationOptionState]) => {
      //   if (!configurationOptionState || !configurationOptionState.fetchedAt) {
      //     console.log('Configuration options never fetched, will fetch')
      //     return true
      //   }

      //   const lastRefreshedAtEpoch = parseInt(
      //     configurationOptionState.fetchedAt.toString()
      //   )

      //   if (lastRefreshedAtEpoch < moment().subtract(1, 'hours').unix()) {
      //     console.log(
      //       `Last configuration options fetch was more then 24 hours ago, will fetch`
      //     )
      //     return true
      //   }

      //   if (!configurationOptionState.entities[0]) {
      //     console.log(`No loaded options foudn, will fetch`)
      //     return true
      //   }

      //   console.log(`Not proceeding configuration options fetch`)

      //   return false
      // }),
      filter((x) => !window.location.href.includes('public-payment-redirect')),
      mergeMap((x) => [
        configurationOptionActions.resetState(),
        configurationOptionActions.fetchMany({})
      ]),
      catchError((error) => {
        console.error('Error while initializing configuration options', error)
        return of(noOperationAction())
      })
    )
  )
  fetchOneByName = createEffect(() =>
    this.actions$.pipe(
      ofType(configurationOptionActions.fetchOneByName),
      concatMap((action) =>
        this.entityService
          .getMany(
            RequestQueryBuilder.create({
              search: { key: action.name }
            })
          )
          .pipe(
            map((entity) => {
              return normalizationActions.upsertMany({
                entities: normalizeToSchema({
                  configurationOptions: entity.data
                })
              })
            })
          )
      )
    )
  )
  fetchManyByName = createEffect(() =>
    this.actions$.pipe(
      ofType(configurationOptionActions.fetchManyByName),
      concatMap((action) =>
        this.entityService
          .getMany(
            RequestQueryBuilder.create({
              search: { key: { [CondOperator.IN]: action.names } }
            })
          )
          .pipe(
            map((entity) => {
              return normalizationActions.upsertMany({
                entities: normalizeToSchema({
                  configurationOptions: entity.data
                })
              })
            })
          )
      )
    )
  )

  cacheConfigurationOptions = createEffect(() =>
    this.actions$.pipe(
      ofType(configurationOptionActions.upsertMany),
      map((action) => {
        this.configurationOptionService.upsertConfigurationOptions(
          action.entities ?? []
        )

        return noOperationAction()
      })
    )
  )
}
